import request from "../utils/request";

export function fetchAICategories(params) {
    return request.get('/ai/category', params);
}

export function fetchAIQuestions(params) {
    return request.get('/ai/question', params);
}

export function createAIQuestion(params) {
    return request.post('/ai/question/create', params);
}

export function updateAIQuestion(params) {
    return request.patch('/ai/question/edit', params);
}

export function deleteAIQuestion(id) {
    return request.dataDel(`/ai/question?id=${id}`);
}

export function fetchAIPrompts(params) {
    return request.get('/ai/prompt', params);
}

export function createAIPrompt(params) {
    return request.post('/ai/prompt/create', params);
}

export function updateAIPrompt(params) {
    return request.patch('/ai/prompt/edit', params);
}

export function deleteAIPrompt(id) {
    return request.dataDel(`/ai/prompt?id=${id}`);
}

export function fetchAISelectors(params) {
    return request.get('/ai/selector', params)
}

export function createAISelector(params) {
    return request.post('/ai/selector/create', params);
}

export function updateAISelector(params) {
    return request.patch('/ai/selector/edit', params);
}

export function deleteAISelector(id) {
    return request.dataDel(`/ai/selector?id=${id}`);
}

export function fetchAISystemPrompts(params) {
    return request.get('/ai/system/prompt', params);
}

export function createAISystemPrompt(params) {
    return request.post('/ai/system/prompt/create', params);
}

export function updateAISystemPrompt(params) {
    return request.patch('/ai/system/prompt/edit', params);
}

export function deleteAISystemPrompt(id) {
    return request.dataDel(`/ai/system/prompt?id=${id}`);
}

export function fetchAIArticleCategorys(params) {
    return request.get('/ai/article/category', params);
}

export function createAIArticleCategory(params) {
    return request.post('/ai/article/category/create', params);
}

export function updateAIArticleCategory(params) {
    return request.patch('/ai/article/category/edit', params);
}

export function deleteAIArticleCategory(id) {
    return request.dataDel(`/ai/article/category?id=${id}`);
}

export function fetchAIArticles(params) {
    return request.get('/ai/article', params);
}

export function updateAIArticle(params) {
    return request.patch('/ai/article/edit', params);
}

export function fetchEconomicEvents(params) {
    return request.get('/events/economic/list', params);
}

export function updateEconomicEvents(params) {
    return request.patch('/events/economic/update', params);
}

export function fetchEarningsEvents(params) {
    return request.get('/events/earnings/list', params);
}

export function updateEarningsEvents(params) {
    return request.patch('/events/earnings/update', params);
}

export function resendEventsNotification(params) {
    return request.post('/events/notification/resend', params);
}

export function fetchInvestmentIdea(params) {
    return request.get('/investment/idea/list', params);
}

export function createInvestmentIdea(params) {
    return request.post('/investment/idea/create', params);
}

export function updateInvestmentIdea(params) {
    return request.patch('/investment/idea/update', params);
}

export function deleteInvestmentIdea(ids) {
    return request.dataDel(`/investment/idea/delete?ids=${ids}`);
}

export function batchUpdateInvestmentIdea(params) {
    return request.patch('/investment/idea/batch/update/status', params);
}

export function fetchDailyInsights(params) {
    return request.get('/daily/insight/list', params);
}

export function createDailyInsights(params) {
    return request.post('/daily/insight/create', params);
}

export function updateDailyInsights(params) {
    return request.patch('/daily/insight/update', params);
}

export function deleteDailyInsights(ids) {
    return request.dataDel(`/daily/insight/delete?ids=${ids}`);
}